import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function LoadingPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col h-screen gap-4 items-center justify-center text-sm">
      <FontAwesomeIcon
        icon={faSpinnerThird}
        size="4x"
        spin
        className="text-primary-blue-B600"
        style={
          {
            '--fa-secondary-color': '#D1D1D6',
          } as React.CSSProperties
        }
      />

      <div className=" text-neutrals-N900 text-sm"> {t('actions.loading')}</div>
    </div>
  );
}
